module.exports = __webpack_public_path__ + "static/img/service_left.fe36093d.png";